var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRightPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.933486 1.37338e-05C1.05634 -0.00064143 1.17813 0.0210718 1.29186 0.0639099C1.4056 0.106748 1.50905 0.169868 1.59627 0.249648L7.19729 5.41446C7.37116 5.57575 7.46875 5.79392 7.46875 6.02133C7.46875 6.24874 7.37116 6.46691 7.19729 6.6282L1.59627 11.793C1.41769 11.934 1.18798 12.0077 0.953038 11.9994C0.718098 11.991 0.495234 11.9012 0.328983 11.7479C0.162731 11.5946 0.0653353 11.3891 0.0562611 11.1724C0.0471869 10.9558 0.127101 10.744 0.280033 10.5793L5.21827 6.02563L0.280034 1.47199C0.14895 1.3521 0.0593605 1.19907 0.022594 1.03223C-0.0141725 0.865396 0.00353674 0.692253 0.0734797 0.534699C0.143423 0.377144 0.262459 0.242253 0.415538 0.14708C0.568618 0.0519069 0.748865 0.000727066 0.933486 1.37338e-05Z",
    fill: "#0065FC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightPrimary);
export default __webpack_public_path__ + "static/media/ChevronRightPrimary.0ea78facab93cf1f3850bb718d99be00.svg";
export { ForwardRef as ReactComponent };